import { Color, MathUtils, ShaderMaterial } from 'three';

import vertexShader from './globeMaterialVertex.glsl';
import fragmentShader from './globeMaterialFragment.glsl';
import AppEngine from '../general/appEngine';

export default class GlobeMaterial extends ShaderMaterial {
  constructor() {
    const uniforms = {
      sdf: { value: null },
      earthColor: { value: new Color(0x213bda).multiplyScalar(2.0) },
      waterColor: { value: new Color(0x040a40).multiplyScalar(2.0) },
      shockColor: { value: new Color(0xba00ff) },
      // shockColor: { value: new Color(0xff30d0) },
      time: { value: 0.0 },
      emissiveMap: { value: null },
      emissiveIntensity: { value: new Color(0x6be4fd).multiplyScalar(2.0) },
      emissivePattern: { value: null },
      normalMap: { value: null },
      normalDetailMap: { value: null },
      noiseMap: { value: null },
      envMap: { value: null },
      envMapIntensity: { value: new Color(0.3, 0.5, 1.0) },
      irradianceMap: { value: null },
      irradianceMapIntensity: { value: 6.0 },
      normalReflectance: { value: 0.02 },
      sdfSharpness: { value: 0.001 },
      normalScale: { value: 2.0 },
      metallicness: { value: 0.3 },
      emissivePatternScale: { value: 20.0 },
      shockPhase: { value: 0.0 },
      exposure: { value: AppEngine.HDR_SCALE },
    };

    super({
      uniforms,
      vertexShader,
      fragmentShader,
      // actually: currently only for ambient
      // lights: true,
      extensions: {
        derivatives: true,
      },
    });
  }

  get sdf() {
    return this.uniforms.sdf.value;
  }

  set sdf(value) {
    this.uniforms.sdf.value = value;
  }

  get sdfSharpness() {
    return this.uniforms.sdfSharpness.value;
  }

  set sdfSharpness(value) {
    this.uniforms.sdfSharpness.value = value;
  }

  get metallicness() {
    return this.uniforms.metallicness.value;
  }

  set metallicness(value) {
    this.uniforms.metallicness.value = value;
  }

  get shockPhase() {
    return this.uniforms.shockPhase.value;
  }

  set shockPhase(value) {
    this.uniforms.shockPhase.value = MathUtils.clamp(value, 0, 1);
  }

  get normalScale() {
    return this.uniforms.normalScale.value;
  }

  set normalScale(value) {
    this.uniforms.normalScale.value = value;
  }

  get earthColor() {
    return this.uniforms.earthColor.value;
  }

  set earthColor(value) {
    this.uniforms.earthColor.value = value;
  }

  get waterColor() {
    return this.uniforms.waterColor.value;
  }

  set waterColor(value) {
    this.uniforms.waterColor.value = value;
  }

  get normalMap() {
    return this.uniforms.normalMap.value;
  }

  set normalMap(value) {
    this.uniforms.normalMap.value = value;
  }

  get normalDetailMap() {
    return this.uniforms.normalDetailMap.value;
  }

  set normalDetailMap(value) {
    this.uniforms.normalDetailMap.value = value;
  }

  get noiseMap() {
    return this.uniforms.noiseMap.value;
  }

  set noiseMap(value) {
    this.uniforms.noiseMap.value = value;
  }

  get normalReflectance() {
    return this.uniforms.normalReflectance.value;
  }

  set normalReflectance(value) {
    this.uniforms.normalReflectance.value = value;
  }

  get emissiveMap() {
    return this.uniforms.emissiveMap.value;
  }

  set emissiveMap(value) {
    this.uniforms.emissiveMap.value = value;
  }

  get emissivePattern() {
    return this.uniforms.emissivePattern.value;
  }

  set emissivePattern(value) {
    this.uniforms.emissivePattern.value = value;
  }

  get emissivePatternScale() {
    return this.uniforms.emissivePatternScale.value;
  }

  set emissivePatternScale(value) {
    this.uniforms.emissivePatternScale.value = value;
  }

  get emissiveIntensity() {
    return this.uniforms.emissiveIntensity.value;
  }

  set emissiveIntensity(value) {
    this.uniforms.emissiveIntensity.value = value;
  }

  get envMap() {
    return this.uniforms.envMap.value;
  }

  set envMap(value) {
    this.uniforms.envMap.value = value;
  }

  get envMapIntensity() {
    return this.uniforms.envMapIntensity.value;
  }

  set envMapIntensity(value) {
    this.uniforms.envMapIntensity.value = value;
  }

  get irradianceMap() {
    return this.uniforms.irradianceMap.value;
  }

  set irradianceMap(value) {
    this.uniforms.irradianceMap.value = value;
  }

  get irradianceMapIntensity() {
    return this.uniforms.irradianceMapIntensity.value;
  }

  set irradianceMapIntensity(value) {
    this.uniforms.irradianceMapIntensity.value = value;
  }

  get time() {
    return this.uniforms.time.value;
  }

  set time(value) {
    this.uniforms.time.value = value;
  }
}
